// src/screens/Mantenedor/MantenedorCampo.jsx
import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

export default function MantenedorCampo() {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">🛠️ Mantenedor</h2>

      {/* Submenú para módulos, sectores y válvulas */}
      <nav className="flex gap-4 mb-6">
        <NavLink
          to="modulos"
          className={({ isActive }) =>
            `px-4 py-2 rounded ${
              isActive ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800'
            }`
          }
        >
          Equipo
        </NavLink>
        <NavLink
          to="sectores"
          className={({ isActive }) =>
            `px-4 py-2 rounded ${
              isActive ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800'
            }`
          }
        >
          Sector
        </NavLink>
        <NavLink
          to="valvulas"
          className={({ isActive }) =>
            `px-4 py-2 rounded ${
              isActive ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800'
            }`
          }
        >
          Válvulas
        </NavLink>
      </nav>

      {/* Aquí se renderiza MantenedorModulo, MantenedorSector o MantenedorValvula */}
      <Outlet />
    </div>
  );
}
